import { motion } from 'framer-motion';
import { BookOpen, Scale, ShieldCheck, ArrowRight } from 'lucide-react';
import '../styles/sections.css';
import './UseCases.css';

const cases = [
  {
    icon: <BookOpen size={24} />,
    title: 'Technical Training Courses',
    text: 'Slide decks, hands-on code labs, assessments, and instructor notes — all generated and verified against a curriculum spec.',
  },
  {
    icon: <Scale size={24} />,
    title: 'Jurisdiction-Verified Legal Documents',
    text: 'Compliance-aware legal drafting with deterministic validation against regional rules and client-approved templates.',
  },
  {
    icon: <ShieldCheck size={24} />,
    title: 'Security, Compliance & IaC',
    text: 'Audit-ready security reports, regulatory filings, and infrastructure-as-code for regulated environments.',
  },
];

export default function UseCases() {
  return (
    <section className="section">
      <div className="container">
        <div className="sectionHeader">
          <span className="sectionLabel">Use Cases</span>
          <h2 className="sectionTitle">Regulated knowledge work, delivered correctly.</h2>
          <p className="sectionSubtitle">
            Two beachhead verticals, one extensible pipeline. Keraunos starts where
            accuracy, auditability, and data sovereignty are non-negotiable.
          </p>
        </div>

        <div className="grid3">
          {cases.map((item, idx) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="useCaseCard glassCard"
            >
              <div className="iconWrap">{item.icon}</div>
              <h3 className="cardTitle">{item.title}</h3>
              <p className="cardText">{item.text}</p>
              <a href="#contact" className="learnMore">
                Learn more <ArrowRight size={16} />
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
